import { Injectable } from '@angular/core';
import { Message } from '../models/chat.model';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map, Observable } from 'rxjs';

  // Define interface for the Lambda response
  interface BedrockResponse {
    text: string;
  }
  

@Injectable({
  providedIn: 'root'
})
export class AIFireService {


  private LAMBDA_API_URL = 'https://zl3itj6lpuzspqp6trle3s5psa0ggsbf.lambda-url.us-east-1.on.aws/';



  constructor(private http: HttpClient) {}

  // callCladius37(prompt: string, history: Message[]): Promise<string> {
  //   // Only send the last 5 messages
  //   const payload = {
  //     prompt,
  //     history: history.slice(-5).map(msg => ({
  //       role: msg.role,
  //       content: msg.content
  //     }))
  //   };

  //   return this.http
  //     .post(this.apiUrl, payload)
  //     .toPromise()
  //     .then(resp => resp.text);
  // }

  generateText(prompt: string, history: Message[]): Promise<string> {
    const payload = {
      prompt,
      history: history.map(msg => ({ role: msg.role, content: msg.content }))
    };

    // Issue the POST and pluck out .text, then convert to Promise
    const text$ = this.http
      .post<BedrockResponse>(this.LAMBDA_API_URL, payload)
      .pipe(map(resp => resp.text));

    return firstValueFrom(text$);
  }



}
